import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register('/service-worker.js', {
    registered() {
      console.log('Service worker has been registered.')
    },

    cached() {
      console.log('Content has been cached for offline use.')
    },

    updatefound() {
      console.log('New content is downloading.')
    },

    updated(registration) {
      // Aplicação tem atualização
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },

    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },

    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
